import React from "react";
import MainContainer from "../../container/MainContainer";
import EditProfileBanner from "./EditProfileBanner";
import EditProfileHeader from "./EditProfileHeader";
import EditBusinessProfile from "./EditBusinessProfile";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { EDIT_BUSINESS_PROFILE } from "../../mutation/EditBusinessProfile";
import { EDIT_CLUB_PROFILE } from "../../mutation/EditClubProfile";
import { hasuraClient } from "../../apolloClient";
import { VIEW_PROFILE } from "../../query/ViewProfile";
import { VIEW_ROLE } from "../../query/ViewRole";

const EditProfileLayout = (props) => {
  const { data: userRole } = useQuery(VIEW_ROLE, {
    variables: {
      userId: localStorage.getItem("user_id"),
    },
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });
  const [BusinessProfile] = useMutation(EDIT_BUSINESS_PROFILE, {
    client: hasuraClient,
  });
  const [ClubProfile] = useMutation(EDIT_CLUB_PROFILE, {
    client: hasuraClient,
  });
  const { data: profile_data, refetch: profile_refetch } = useQuery(
    VIEW_PROFILE,
    {
      client: hasuraClient,
    }
  );

  return (userRole?.users[0].role==="business" ?
    <MainContainer className="edit-profile-main" active="businessProfile">
      <section className="council-cover">
        <EditProfileBanner
          data={profile_data}
          BusinessProfile={BusinessProfile}
          refetch={profile_refetch}
        />
        <div className="council-row">
          <EditProfileHeader
            data={profile_data}
            BusinessProfile={BusinessProfile}
            refetch={profile_refetch}
          />
          <EditBusinessProfile />
        </div>
      </section>
    </MainContainer> : <MainContainer className="edit-profile-main" active="businessProfile">
      <section className="council-cover">
        <EditProfileBanner
          data={profile_data}
          BusinessProfile={ClubProfile}
          refetch={profile_refetch}
        />
        <div className="council-row">
          <EditProfileHeader
            data={profile_data}
            BusinessProfile={ClubProfile}
            refetch={profile_refetch}
          />
          <EditBusinessProfile />
        </div>
      </section>
    </MainContainer>
  );
};

export default EditProfileLayout;
